var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 350 180",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .small {\n        font: 150px 'Caveat';\n        fill: black;\n        }\n\n\n    ")), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 130,
    className: "small"
  }, "\n        sp", /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "#00b96b"
    }
  }, "ai"), "k\n    "));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseLogo);
export default __webpack_public_path__ + "static/media/base_logo.0a11e1d8e9d880d0408bef815ebab8c6.svg";
export { ForwardRef as ReactComponent };